import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../images/logo11.png'; 
import LogoutIcon from '@mui/icons-material/Logout';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineClose } from 'react-icons/md'; 
import './navbar.css';

const NavbarComponent = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavbarToggle = () => {
    setNavbarOpen(!navbarOpen);
    setDropdownVisible(false);
    document.body.classList.toggle('menu-open');
  };

  const handleLogout = async () => {
    try {
      await logout();
      setDropdownVisible(false);
      setNavbarOpen(false);
      document.body.classList.remove('menu-open');
      navigate('/login'); 
    } catch (error) {
      console.error('Logout error:', error);
    }
  }; 

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdownVisible((prev) => !prev);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {  
      setDropdownVisible(false);  
    }
  }, [isAuthenticated]);

  // Close menu when navigating
  useEffect(() => {
    setNavbarOpen(false);
    document.body.classList.remove('menu-open');
  }, [location]);

  const getInitials = (name) => {
    const names = name.split(' ');
    return names.length === 1 ? name : names.map((n) => n.charAt(0).toUpperCase()).join('');
  };

  const closeDropdown = () => {
    setDropdownVisible(false);
  };

  return (
    <nav id="mainMenu" className={`main-menu ${navbarOpen ? 'open' : ''}`}>
      <div className="Menu_container">
        <Link to="/" className="logo-container">
          <img src={Logo} className="logo-img" alt="Nav Logo" />
        </Link>

        <div className={`nav-links ${navbarOpen ? 'show' : ''}`}>
          <NavLink to="/" onClick={handleNavbarToggle}>Home</NavLink>
          <NavLink to="/about" onClick={handleNavbarToggle}>About</NavLink>
          <NavLink to="/service" onClick={handleNavbarToggle}>Services</NavLink>
          <NavLink to="/contact" onClick={handleNavbarToggle}>Contact</NavLink>

          {!isAuthenticated ? (
            <>
              <NavLink to="/login" onClick={handleNavbarToggle}>Sign In</NavLink>
              <NavLink to="/makerequest" className="signup-btn" onClick={handleNavbarToggle}>
                Candidate Request
              </NavLink>
            </>
          ) : (
            <>
              <NavLink to="/makerequest" onClick={handleNavbarToggle}>Candidate Request</NavLink>

              <div className="user-profile-nav" onClick={toggleDropdown}>
                {user?.role !== 'admin' ? (
                  <div className="profile-initials">
                    {getInitials(user.userName)}
                  </div>
                ) : (
                  <div className="admin-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11V11.99z"/>
                    </svg>
                  </div>
                )}
                {dropdownVisible && (
                  <div ref={dropdownRef} className="user-dropdown-menu">
                    <NavLink 
                      to={user?.role === 'admin' ? '/admin' : '/userdashboard'} 
                      className="dropdown-item" 
                      onClick={() => {
                        closeDropdown();
                        handleNavbarToggle(); 
                      }}
                    >
                      Dashboard
                    </NavLink>
                    <button 
            onClick={handleLogout} 
            className="dropdown-item btn-logout"
          >
            <LogoutIcon fontSize="small" />
            <span>Logout</span>
          </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <button 
          className="menu-toggle" 
          onClick={handleNavbarToggle} 
          aria-label={navbarOpen ? "Close menu" : "Open menu"}
          aria-expanded={navbarOpen}
        >
          {navbarOpen ? <MdOutlineClose size={28} /> : <GiHamburgerMenu size={28} />}
        </button>
      </div>
    </nav>
  );
};

export default NavbarComponent;